<template lang="pug">
    Modal(v-if="unsaved_changes_alert_show", @close="close_modal" )
        span(slot="header") {{t('app.modal.title.unsaved_changes')}}
        template(slot="content")
            .modal-content.centered
                small
                    | {{t("app.modal.body.unsaved_changes.program")}}

                .buttons
                    button(class="button alert left" @click="unsaved_changes_alert_method(), close_modal(true)") {{t('app.buttons.leave_without_saving')}}
                    button(type="button" @click="close_modal(false)" class="button right") {{t('app.buttons.stay_on_page')}}
                    br
                    br

</template>
<script>
    import Modal from "../templates/shared/_modal";
    export default{
        components: {Modal},
        computed: {
            unsaved_changes_alert_show(){
                return this.$store.state.unsaved_changes_alert_show
            },
            unsaved_changes_alert_method(){
                return this.$store.state.unsaved_changes_alert_method
            }
        },
        methods: {
            close_modal(skip){
                if(skip){
                  window.vue_unsaved_changes = false
                }
                this.$store.state.unsaved_changes_alert_show=false
            }
        }

    }
</script>
